import React from 'react'
import Layout from '../Components/Layouts/Layout'
import { Box, Typography } from '@mui/material'

const About = () => {
  return (
    <Layout> 
      <Box sx={{
        my: 15,
        textAlign: 'center',
        p:2,
        "& h4": {
          fontWeight: 'bold',
          my:2,
          fontSize: '2rem'
        },
        "& p":{
          textAlign: 'justify'
        },

        "@media (max-width:600px)":{
          mt:2,
          "& h4":{
            fontSize: '1.5rem',
          }
        }

      }}>
        <Typography variant='h4'>WellCome To My Resturant.</Typography>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem totam neque esse corporis doloribus corrupti unde, ut quae. Saepe, accusamus delectus blanditiis tempora commodi recusandae quasi adipisci qui exercitationem quae itaque aperiam officiis perferendis expedita deleniti aliquid inventore dolorem omnis enim! Eos, labore esse cupiditate repellendus minima inventore nihil. Harum, minus eos officia ea ratione tempora? Pariatur consequuntur ipsum, animi minus magnam tempora modi enim. Modi debitis ad, libero quo eius doloribus rerum aperiam nemo aspernatur architecto similique distinctio quidem et necessitatibus magnam, veritatis repellendus praesentium quibusdam laboriosam vitae vero iste maxime est. Eveniet molestiae adipisci doloribus tenetur non ullam.</p>
        <br/>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas dignissimos eum esse nulla similique, accusamus a. Omnis amet facilis pariatur soluta nesciunt optio repudiandae harum velit qui eaque. Possimus, consectetur illo ipsa dolore, esse, tempora voluptatum qui totam harum praesentium perferendis molestiae cupiditate aliquid adipisci enim omnis aspernatur? Incidunt, corrupti quos eligendi autem exercitationem alias quam fuga atque sapiente mollitia quis numquam necessitatibus repudiandae quaerat vitae ducimus et ipsam optio praesentium eius possimus id voluptatum? Repellendus praesentium ducimus iusto rerum, voluptatibus qui quidem et eaque sapiente recusandae excepturi maiores culpa, nam sed consequuntur mollitia laboriosam cumque quae iure accusamus labore.</p>
      </Box>
    </Layout>
     
    
  )
}

export default About
